import { useFormik } from 'formik';
import React from 'react';
import { Input } from '../../Components/UI/Input';
import { emailSchema } from '../../Schema';
import AlertModal from '../AlertModal';
import classes from './ChangedEmail.module.css';
import ModalAction from '../ModalAction';
import { useDispatch } from 'react-redux';
import { setHoldEmail } from '../../Store/commonSlice';
const initialValues = {
  email: ''
};
const ChangedEmailModal = ({
  onSubmit,
  setShow,
  data,
  show,
  loading,
  setShowOtpVerificationModal
}) => {
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues,
    validationSchema: emailSchema,
    onSubmit: (values, { resetForm }) => {
      const params = {
        ...values
      };
      onSubmit(params, () => {
        dispatch(setHoldEmail(values?.email));
        setShowOtpVerificationModal(true);
        setShow(false);
        resetForm();
      });
    }
  });
  const { touched, errors, values, handleSubmit, resetForm, setFieldValue, setFieldTouched } =
    formik;
  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  const onCancel = () => {
    dispatch(setHoldEmail());
    setShow(false);

    resetForm();
  };
  return (
    <AlertModal
      title={'Changed Email'}
      show={show}
      setShow={() => {
        dispatch(setHoldEmail());
        setShow(false);
      }}
      actions={false}>
      <form onSubmit={handleSubmit}>
        <Input
          placeholder="Enter Email"
          id={'changed-email-modal'}
          setter={(e) => {
            handleChangeWithTouch('email', e);
          }}
          errorText={errors?.email}
          value={touched?.email && values?.email}
        />
        <p className={classes.note}>We will send you a confirmation code</p>
        <ModalAction
          type="submit"
          isApiCall={loading}
          className={classes.actions}
          onCancel={() => {
            if (typeof onCancel === 'function') onCancel();
          }}
        />
      </form>
    </AlertModal>
  );
};

export default ChangedEmailModal;
